// Loading skeleton for the location edit page (GRAIN-1930). Unlike EditSkeleton
// it has NO image placeholder — the location edit form is two text fields
// (postal code + notes) over a configurations section. Keep in sync with
// Components::Skeletons::LocationEdit so React hydrates the server-rendered
// skeleton without restarting the shimmer.

import {
  Bar,
  DetailFooter,
  DetailHeader,
  DEFAULT_LABEL,
  PageShell,
  TwoColumnInput,
} from './primitives';

export function LocationEditSkeleton({ label = DEFAULT_LABEL }: { label?: string }) {
  return (
    <PageShell label={label}>
      <DetailHeader crumbs={3} />
      <div className="flex-1">
        <div className="w-full px-16 pt-8 pb-12 space-y-10">
          <section>
            {/* EDIT LOCATION title */}
            <Bar className="h-[30px] w-44 mb-6" />
            {/* postal code | notes */}
            <TwoColumnInput />
          </section>
          <section>
            {/* Configurations heading */}
            <Bar className="h-[30px] w-44 mb-6" />
            <div className="rounded-input border border-dinnerplate-white p-6">
              {/* a configuration row: type | notes */}
              <TwoColumnInput />
            </div>
          </section>
        </div>
      </div>
      <DetailFooter buttonClass="h-[42px] w-[131px]" />
    </PageShell>
  );
}
